<template>
  <div class="flex flex-column flex-1">
    <u-header show-back>上传头像</u-header>
    <div class="scrollable container flex-1 flex flex-column">
      <avatar-crop :default-image="currentAvatar"
        show-circle return-base64 @change="onAvatarChange">
      </avatar-crop>
      <template v-if="btnVisible">
        <u-progress v-if="percent>0&&percent<100" :percent="percent"></u-progress>
        <u-button type="primary" @click="upload">上传</u-button>
      </template>
    </div>
  </div>
</template>
<script>
import AV from 'leancloud-storage'
import { mapActions } from 'vuex'
import AvatarCrop from '@/components/AvatarCrop.vue'
export default {
  data () {
    return {
      percent: 0,
      btnVisible: false,
      rts: null,
      currentAvatar: this.$store.getters.user.avatar,
      base64: ''
    }
  },
  components: {
    AvatarCrop
  },
  methods: {
    ...mapActions(['updateUser']),
    onAvatarChange (base64) {
      this.btnVisible = true
      this.base64 = base64
    },
    upload () {
      const file = new AV.File('avatar.jpg', { base64: this.base64 });
      file.save({
        onprogress: e =>  {
          this.percent = e.percent
        }
      }).then(data => {
        this.$toast('头像已上传')
        const url = data.url()
        this.updateUser({ avatar: url })
        return AV.User.current().set('avatar', url).save()
      }).catch(error => {
        this.$toast('头像上传失败，请稍后重试')
        console.error(error)
      }).then(() => {
        this.$router.go(-1)
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// Avatar.vue?0de9408d